export default __webpack_public_path__ + "static/media/business_process_outsourcing-bk.817e450b.svg";